<main>

    <form (ngSubmit)="submit()" #f="ngForm" novalidate disableAutofill>
        <!-- Department -->
        <label for="dept">Department Name</label>
        <select id="dept" [(ngModel)]="filters.department" name="department">
            <option [ngValue]="null">Select a department</option>
            <option *ngFor="let d of departments" [value]="d.id">{{ d.name }}</option>
        </select>

        <!-- Date Range -->
        <fieldset>
            <legend>Date Range</legend>
            <div class="inline">
                <mat-form-field appearance="outline">
                    <mat-label>Start date</mat-label>
                    <input matInput [matDatepicker]="pickerStart" [(ngModel)]="filters.start_date" name="start_date">
                    <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStart></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>End date</mat-label>
                    <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="filters.end_date" name="end_date">
                    <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEnd></mat-datepicker>
                </mat-form-field>
            </div>
        </fieldset>

        <!-- Form Types -->
        <fieldset *ngIf="filters.department">
            <legend>Forms Types</legend>

            <div class="form-type-list">
                <label style="text-transform: capitalize;" *ngFor="let form of selectedDeptForms">
                    <input
                        type="checkbox"
                        [(ngModel)]="filters.formTypeMap[form.id]"
                        name="form_{{form.id}}"
                    />
                    {{ form.frequency }}
                </label>
            </div>

            <p *ngIf="selectedDeptForms.length === 0" class="hint text-gray-500">
                No forms found for this department.
            </p>
            </fieldset>

        <!-- Status -->
        <fieldset>
            <legend>Status</legend>
            <div class="inline" aria-label="Status" role="radiogroup">
                <label><input type="radio" [(ngModel)]="filters.status" name="status" value="all" /> All</label>
                <label><input type="radio" [(ngModel)]="filters.status" name="status" value="submitted" /> Submitted</label>
                <label><input type="radio" [(ngModel)]="filters.status" name="status" value="unsubmitted" /> Unsubmitted</label>
            </div>
        </fieldset>

        <div class="actions">
            <button type="submit" *ngIf="!submitting">Create Export</button>

            <img class="loader" *ngIf="submitting" src="assets/loader.gif" alt="">
        </div>


        <p *ngIf="file_link" class="text-center">The requested file has been created and will open automatically <br>Otherwise, it can be accessed by <a [href]="file_link" target="_blank">clicking here</a></p>
    </form>

</main>